import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Checkbox,
  Input,
  Button,
  Dropdown,
  Radio
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardCreateInvoiceGroupUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardCreateInvoiceGroupUX-div-0"
        style={{backgroundColor: "#FFFFF",width: "calc(-150px + 100vw)",height: "calc(100vh - 30px)" ,padding:"10px",borderRadius: 3,border : "solid 0.5px ",borderColor:"transparent", overflow: "auto", }}>
        <div
          id="CardCreateInvoiceGroupUX-div-371"
          style={{display: "flex", marginBottom: "0.75rem"}}>
          
          <Button
            color={props.activeTab === "IssueInv"? "blue":""}
            id="CardCreateInvoiceGroupUX-Button-372"
            name="IssueInv"
            onClick={props.onChangeTab}
            size="small"
            style={{marginRight: "0.75rem"}}>
            {props.languageUX === "en" ? "Issue Invoice to the parent company" : "ออกใบแจ้งหนี้เรียกเก็บเงินต้นสังกัด"}
          </Button>
          <Button
            color={props.activeTab === "InvIssued"? "blue":""}
            id="CardCreateInvoiceGroupUX-Button-373"
            name="InvIssued"
            onClick={props.onChangeTab}
            size="small"
            style={{marginRight: "0.75rem"}}>
            {props.languageUX === "en" ? "Invoiced Items" : "รายการที่ออกใบแจ้งหนี้แล้ว"}
          </Button>
        </div>
        <div
          id="CardCreateInvoiceGroupUX-div-182">
          <div
            id="CardCreateInvoiceGroupUX-div-183"
            style={{display: "flex",height:"100%", fontSize:"1.15rem",fontWeight:"bold",alignItems:"center", padding: "2.5px 0px"}}>
            
            <label
              id="CardCreateInvoiceGroupUX-label-184">
              {props.table?.title || "-"}
            </label>
          </div>
          <div
            className="ui divider"
            id="CardCreateInvoiceGroupUX-div-374"
            style={{marginTop: "0.5rem"}}>
            
          </div>
        </div>
        <div
          className="ui form small"
          id="CardCreateInvoiceGroupUX-div-158"
          style={{display:props.activeTab==="IssueInv"?"":"none"}}>
          
          <FormGroup
            id="CardCreateInvoiceGroupUX-FormGroup-159"
            inline={true}>
            <FormField
              className="required"
              id="CardCreateInvoiceGroupUX-FormField-160"
              inline={true}>
              <label
                id="CardCreateInvoiceGroupUX-label-375">
                {props.languageUX === "en" ? "Select rights" : "เลือกสิทธิ"}
              </label>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-166"
              inline={true}
              width={3}>
              <Dropdown
                className="inline-label"
                fluid={true}
                id="CardCreateInvoiceGroupUX-Dropdown-376"
                name="filterIssueInv.coveragePayer"
                onChange={props.onChangeFilter}
                options={props.coveragePayerOptions}
                search={true}
                selection={true}
                style={{width: "100%", fontSize: "1em"}}
                value={props.filterIssueInv?.coveragePayer|| ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-161"
              inline={true}
              width={1}>
              <Checkbox
                checked={props.filterIssueInv?.isDate}
                id="CardCreateInvoiceGroupUX-Checkbox-175"
                label={props.languageUX === "en" ? "Receipt date" : "วันที่ออกใบเสร็จ"}
                name="filterIssueInv.isDate"
                onChange={props.onChangeFilter}
                style={{minWidth: "max-content"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-162"
              inline={true}
              width={2}>
              <div
                id="CardCreateInvoiceGroupUX-div-171"
                style={{width: "100%"}}>
                
                <DateTextBox
                  disabled={!props.filterIssueInv?.isDate}
                  id="CardCreateInvoiceGroupUX-DateTextBox-178"
                  onChange={(value: string)=>props.onChangeFilter?.(null,{name:"filterIssueInv.startDate", value})}
                  style={{width: "100%"}}
                  value={props.filterIssueInv?.startDate || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-167"
              inline={true}>
              <div
                id="CardCreateInvoiceGroupUX-div-181"
                style={{textAlign: "center", width: "100%"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-163"
              inline={true}
              width={2}>
              <div
                id="CardCreateInvoiceGroupUX-div-172"
                style={{width: "100%"}}>
                
                <DateTextBox
                  disabled={!props.filterIssueInv?.isDate}
                  id="CardCreateInvoiceGroupUX-DateTextBox-179"
                  onChange={(value: string)=>props.onChangeFilter?.(null,{name:"filterIssueInv.endDate", value})}
                  style={{width: "100%"}}
                  value={props.filterIssueInv?.endDate || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-164"
              inline={true}>
              <div
                id="CardCreateInvoiceGroupUX-div-173"
                style={{textAlign: "center", width: "100%"}}>
                {props.languageUX === "en" ? "The parent company that collects the fee" : "หน่วยงานต้นสังกัดที่เรียกเก็บ"}
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-165"
              inline={true}
              width={3}>
              <Dropdown
                className="inline-label"
                clearable={true}
                fluid={true}
                id="CardCreateInvoiceGroupUX-Dropdown-377"
                name="filterIssueInv.payer"
                onChange={props.onChangeFilter}
                options={props.payerOptions }
                search={true}
                selection={true}
                style={{width: "100%", fontSize: "1em"}}
                value={props.filterIssueInv?.payer|| ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-169"
              inline={true}>
              <div
                id="CardCreateInvoiceGroupUX-div-352">
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardCreateInvoiceGroupUX-FormGroup-234"
            inline={true}>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-354"
              inline={true}
              style={{minWidth: "max-content", display: "none"}}>
              <Checkbox
                checked={props.filterIssueInv?.isNoInvoice}
                id="CardCreateInvoiceGroupUX-Checkbox-364"
                label={props.languageUX === "en" ? "Only items that have not yet been invoiced" : "เฉพาะรายการที่ยังไม่ถูกสร้างใบแจ้งหนี้"}
                name="filterIssueInv.isNoInvoice"
                onChange={props.onChangeFilter}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-355"
              inline={true}
              style={{display: "none"}}
              width={3}>
              <Checkbox
                checked={props.checkedInvoiceType === "fromPayer"}
                id="CardCreateInvoiceGroupUX-Checkbox-365"
                label={props.languageUX === "en" ? "Invoice number from the parent company" : "เลขที่ใบแจ้งหนี้เรียกเก็บจากต้นสังกัด"}
                onClick={props.onCheckRadio?.("fromPayer")}
                style={{display: "none"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-358"
              inline={true}
              style={{display: "none"}}
              width={3}>
              <div
                id="CardCreateInvoiceGroupUX-div-359"
                style={{width: "100%"}}>
                {props.arInvoiceSearch}
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-378"
              inline={true}
              style={{marginLeft: "1rem"}}
              width={3}>
              <Checkbox
                checked={props.filterIssueInv?.isPatient}
                id="CardCreateInvoiceGroupUX-Checkbox-380"
                label={props.languageUX === "en" ? "HN" : "HN"}
                name="filterIssueInv.isPatient"
                onChange={props.onChangeFilter}
                style={{minWidth: "max-content"}}>
              </Checkbox>
              <div
                id="CardCreateInvoiceGroupUX-div-379"
                style={{width: "100%"}}>
                {props.issueInvPatientSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-414"
              inline={true}
              width={3}>
              <Checkbox
                checked={props.filterIssueInv?.isEncounter}
                id="CardCreateInvoiceGroupUX-Checkbox-415"
                label={props.languageUX === "en" ? "AN" : "AN"}
                name="filterIssueInv.isEncounter"
                onChange={props.onChangeFilter}
                style={{minWidth: "max-content"}}>
              </Checkbox>
              <div
                id="CardCreateInvoiceGroupUX-div-416"
                style={{width: "100%"}}>
                {props.issueInvSearchEncounter}
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-427"
              inline={true}
              width={7}>
              <div
                id="CardCreateInvoiceGroupUX-div-428"
                style={{minWidth: "max-content"}}>
                
                <Checkbox
                  checked={props.filterIssueInv?.isStation || false}
                  id="CardCreateInvoiceGroupUX-Checkbox-430"
                  label={props.languageUX === "en" ? "Payment Point" : "จุดรับชำระเงิน"}
                  name="filterIssueInv.isStation"
                  onChange={props.onChangeFilter}>
                </Checkbox>
              </div>
              <div
                id="CardCreateInvoiceGroupUX-div-429"
                style={{width: "100%"}}>
                
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardCreateInvoiceGroupUX-Dropdown-431"
                  multiple={true}
                  name="filterIssueInv.station"
                  onChange={props.onChangeFilter}
                  options={props.bilStationOptions}
                  search={true}
                  selection={true}
                  value={props.filterIssueInv?.station}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          className="ui form small"
          id="CardCreateInvoiceGroupUX-div-381"
          style={{display:props.activeTab==="InvIssued"?"":"none"}}>
          
          <FormGroup
            className="--override-disabled --grey"
            id="CardCreateInvoiceGroupUX-FormGroup-382"
            inline={true}>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-384"
              inline={true}
              style={{minWidth: "max-content"}}>
              <label
                id="CardCreateInvoiceGroupUX-label-388">
                {props.languageUX === "en" ? "Invoice number from the parent company" : "เลขที่ใบแจ้งหนี้เรียกเก็บเงินจากต้นสังกัด"}
              </label>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-385"
              inline={true}
              width={3}>
              <div
                id="CardCreateInvoiceGroupUX-div-389"
                style={{width: "100%"}}>
                {props.searchInvoiceGroup}
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-386"
              inline={true}
              width={3}>
              <label
                id="CardCreateInvoiceGroupUX-label-390">
                {props.languageUX === "en" ? "Rights" : "สิทธิ"}
              </label>
              <Input
                disabled={true}
                fluid={true}
                id="CardCreateInvoiceGroupUX-Input-395"
                value={props.filterInvIssued?.arTransaction?.coverage_code_name||""}>
              </Input>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-387"
              inline={true}
              width={5}>
              <label
                id="CardCreateInvoiceGroupUX-label-391"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "The parent company that collects the fee" : "หน่วยงานต้นสังกัดที่เรียกเก็บ"}
              </label>
              <Input
                disabled={true}
                fluid={true}
                id="CardCreateInvoiceGroupUX-Input-394"
                value={props.filterInvIssued?.arTransaction?.payer_code_name||""}>
              </Input>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-392">
              <div
                id="CardCreateInvoiceGroupUX-div-393">
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardCreateInvoiceGroupUX-FormGroup-383"
            inline={true}>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-396"
              inline={true}
              width={1}>
              <Checkbox
                checked={props.filterInvIssued?.isDate|| false}
                id="CardCreateInvoiceGroupUX-Checkbox-404"
                label={props.languageUX === "en" ? "Receipt Date" : "วันที่ออกใบเสร็จ"}
                name="filterInvIssued.isDate"
                onChange={props.onChangeFilter}
                style={{minWidth: "max-content"}}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-397"
              inline={true}
              width={2}>
              <div
                id="CardCreateInvoiceGroupUX-div-405"
                style={{width: "100%"}}>
                
                <DateTextBox
                  disabled={!props.filterInvIssued?.isDate}
                  id="CardCreateInvoiceGroupUX-DateTextBox-412"
                  onChange={(value: string)=>props.onChangeFilter?.(null,{name:"filterInvIssued.startDate", value})}
                  style={{width: "100%"}}
                  value={props.filterInvIssued?.startDate || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-398"
              inline={true}>
              <label
                id="CardCreateInvoiceGroupUX-label-407"
                style={{textAlign: "center", width: "100%"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </label>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-399"
              inline={true}
              width={2}>
              <div
                id="CardCreateInvoiceGroupUX-div-406"
                style={{width: "100%"}}>
                
                <DateTextBox
                  disabled={!props.filterInvIssued?.isDate}
                  id="CardCreateInvoiceGroupUX-DateTextBox-413"
                  onChange={(value: string)=>props.onChangeFilter?.(null,{name:"filterInvIssued.endDate", value})}
                  style={{width: "100%"}}
                  value={props.filterInvIssued?.endDate || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-400"
              inline={true}>
              <Checkbox
                checked={props.filterInvIssued?.isPatient|| false}
                id="CardCreateInvoiceGroupUX-Checkbox-408"
                label={props.languageUX === "en" ? "HN" : "HN"}
                name="filterInvIssued.isPatient"
                onChange={props.onChangeFilter}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-401"
              inline={true}
              width={2}>
              <div
                id="CardCreateInvoiceGroupUX-div-411"
                style={{width: "100%"}}>
                {props.invIssuedPatientSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-402"
              inline={true}>
              <Checkbox
                checked={props.filterInvIssued?.isEncounter|| false}
                id="CardCreateInvoiceGroupUX-Checkbox-409"
                label={props.languageUX === "en" ? "AN" : "AN"}
                name="filterInvIssued.isEncounter"
                onChange={props.onChangeFilter}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-403"
              inline={true}
              width={2}>
              <div
                id="CardCreateInvoiceGroupUX-div-410"
                style={{width: "100%"}}>
                {props.invIssuedSearchEncounter}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardCreateInvoiceGroupUX-FormGroup-419"
            inline={true}>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-421"
              inline={true}
              width={8}>
              <div
                id="CardCreateInvoiceGroupUX-div-425"
                style={{minWidth: "max-content"}}>
                
                <Checkbox
                  checked={props.filterInvIssued?.isStation || false}
                  id="CardCreateInvoiceGroupUX-Checkbox-426"
                  label={props.languageUX === "en" ? "Payment Point" : "จุดรับชำระเงิน"}
                  name="filterInvIssued.isStation"
                  onChange={props.onChangeFilter}>
                </Checkbox>
              </div>
              <div
                id="CardCreateInvoiceGroupUX-div-423"
                style={{width: "100%"}}>
                
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardCreateInvoiceGroupUX-Dropdown-424"
                  multiple={true}
                  name="filterInvIssued.station"
                  onChange={props.onChangeFilter}
                  options={props.bilStationOptions}
                  search={true}
                  selection={true}
                  value={props.filterInvIssued?.station}>
                </Dropdown>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <Table
          className="--rt-tbody-overflow-y-hidden"
          data={props.billingTransactionItems}
          headers=" Date Transaction,เลขที่ใบแจ้งหนี้,HN, Encounter, ID Card No.,Invoice No.,Bill No.,จุดรับชำระเงิน,Amount, Claim Amount, Paid, สิทธิ,ต้นสังกัด, "
          id="CardCreateInvoiceGroupUX-Table-308"
          keys="dt_tran,lot_no,hn,encounter_id,pid,invoice_no,bill_no,station_detail,amount,claim_amount,paid,coverage_payer,payer,detail"
          minRows="8"
          showPagination={false}
          style={{height: "calc(100dvh - 27.5rem)"}}
          widths="125,^110,^85,^85,^120,^140,^75,^150,^100,^100,^100,^105,^135,100">
        </Table>
        <div
          id="CardCreateInvoiceGroupUX-div-433"
          style={{ display: "flex", flex: "1 0 auto" , margin: "5px", justifyContent: "flex-end"}}>
          {props.paginationComponent}
        </div>
        <div
          className="ui form small"
          id="CardCreateInvoiceGroupUX-div-309"
          style={{paddingTop: "20px"}}>
          
          <FormGroup
            className="--override-disabled --grey"
            id="CardCreateInvoiceGroupUX-FormGroup-310"
            inline={true}>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-328"
              width={8}>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-312"
              inline={true}
              style={{minWidth: "max-content"}}>
              <div
                id="CardCreateInvoiceGroupUX-div-320"
                style={{textAlign: "right", width: "100%"}}>
                {props.languageUX === "en" ? "Amount of data available for withdrawal" : "จำนวนข้อมูลที่เบิกได้"}
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-313"
              inline={true}
              width={2}>
              <Input
                disabled={true}
                id="CardCreateInvoiceGroupUX-Input-324"
                readOnly={true}
                style={{ textAlign: "right" }}
                value={props.summary?.total_rows ?? ""}>
              </Input>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-314"
              inline={true}
              style={{minWidth: "max-content"}}>
              <div
                id="CardCreateInvoiceGroupUX-div-321"
                style={{textAlign: "center", width: "100%"}}>
                {props.languageUX === "en" ? "Total withdrawal" : "ยอดเบิก"}
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-315"
              inline={true}
              width={2}>
              <Input
                disabled={true}
                id="CardCreateInvoiceGroupUX-Input-325"
                readOnly={true}
                style={{ textAlign: "right" }}
                value={props.summary?.total_sent_claim_price|| ""}>
              </Input>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-316"
              inline={true}
              style={{minWidth: "max-content"}}>
              <div
                id="CardCreateInvoiceGroupUX-div-322"
                style={{textAlign: "center", width: "100%"}}>
                {props.languageUX === "en" ? "Total patient payments" : "ยอดผู้ป่วยจ่าย"}
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-317"
              inline={true}
              width={2}>
              <Input
                disabled={true}
                id="CardCreateInvoiceGroupUX-Input-326"
                readOnly={true}
                style={{ textAlign: "right" }}
                value={props.summary?.total_paid|| props.summary?.total_paid_price|| ""}>
              </Input>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-318"
              inline={true}
              style={{minWidth: "max-content"}}>
              <div
                id="CardCreateInvoiceGroupUX-div-323"
                style={{textAlign: "center", width: "100%"}}>
                {props.languageUX === "en" ? "Co-payment amount" : "ยอดร่วมจ่าย"}
              </div>
            </FormField>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-319"
              inline={true}
              width={2}>
              <Input
                disabled={true}
                id="CardCreateInvoiceGroupUX-Input-327"
                style={{ textAlign: "right" }}
                value={props.summary?.total_other_pay|| props.summary?.total_other_pay_price|| ""}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardCreateInvoiceGroupUX-FormGroup-311"
            inline={true}>
            <div
              className="field"
              id="CardCreateInvoiceGroupUX-div-369"
              style={{flex: 1}}>
              
            </div>
            <FormField
              id="CardCreateInvoiceGroupUX-FormField-338">
              <div
                id="CardCreateInvoiceGroupUX-div-343"
                style={{display: "flex", justifyContent: "space-between", flex: "1", paddingTop: "15px"}}>
                
                <Button
                  color="blue"
                  id="CardCreateInvoiceGroupUX-Button-344"
                  onClick={props.onCreateAR}
                  size="small"
                  style={{display: props.table?.buttons?.includes("create_ar")? "":"none",}}>
                  {props.languageUX === "en" ? "Create reimbursement data" : "สร้างข้อมูลส่งเบิก"}
                </Button>
                <div
                  id="CardCreateInvoiceGroupUX-div-370"
                  style={{display: props.table?.buttons?.includes("create_ar_transaction")?"":"none", marginLeft: "0.75rem"}}>
                  {props.buttonCreate}
                </div>
                <div
                  id="CardCreateInvoiceGroupUX-div-432"
                  style={{display: props.table?.buttons?.includes("cancel_ar")? "":"none", marginLeft: "0.75rem"}}>
                  {props.buttonCancel}
                </div>
                <div
                  id="CardCreateInvoiceGroupUX-div-418"
                  style={{display: props.table?.buttons?.includes("print_report")? "":"none", marginLeft: "0.75rem"}}>
                  {props.buttonPrint}
                </div>
                <div
                  id="CardCreateInvoiceGroupUX-div-417"
                  style={{display: props.table?.buttons?.includes("download_excel")? "":"none", marginLeft: "0.75rem"}}>
                  {props.buttonDownloadExcel}
                </div>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardCreateInvoiceGroupUX-div-245"
          style={{display: "none"}}>
          
          <div
            id="CardCreateInvoiceGroupUX-div-246"
            style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(40, 1fr)","gridTemplateColumns":"repeat(50, 1fr)"}}>
            <div
              id="CardCreateInvoiceGroupUX-div-247"
              style={{ gridRow: "2/4", gridColumn: "2/50"}}>
              <div
                id="CardCreateInvoiceGroupUX-div-248"
                style={{display: "flex",height:"100%", fontSize:"18px",fontWeight:"bold",alignItems:"center"}}>
                
                <label
                  id="CardCreateInvoiceGroupUX-label-249">
                  {props.languageUX === "en" ? "Issue invoices to the parent company" : "ออกใบแจ้งหนี้เรียกเก็บเงินต้นสังกัด"}
                </label>
              </div>
              <hr
                id="CardCreateInvoiceGroupUX-hr-250">
              </hr>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-251"
              style={{ gridRow: "8/32", gridColumn: "2/50"}}>
              <Table
                defaultPageSize="10"
                headers=" ,Date Transaction,เลขที่ใบแจ้งหนี้,HN, Encounter, ID Card No.,Bill No., Amount, Claim Amount, Paid, สิทธิ,ต้นสังกัด, "
                id="CardCreateInvoiceGroupUX-Table-252"
                showPagination={false}>
              </Table>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-253"
              style={{ gridRow: "33/34", gridColumn: "28/30"}}>
              <label
                id="CardCreateInvoiceGroupUX-label-254"
                style={{ marginLeft:"10px",display: "flex",height:"40px", fontSize:"16px",alignItems:"center",fontWeight:"bold"}}>
                {props.languageUX === "en" ? "Total withdrawal" : "ยอดเบิก"}
              </label>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-255"
              style={{ gridRow: "33/34", gridColumn: "30/35"}}>
              <Input
                id="CardCreateInvoiceGroupUX-Input-256"
                readonly="true">
              </Input>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-257"
              style={{ gridRow: "33/34", gridColumn: "40/40"}}>
              <Input
                id="CardCreateInvoiceGroupUX-Input-258"
                readonly="true">
              </Input>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-259"
              style={{ gridRow: "33/34", gridColumn: "39/40"}}>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-260"
              style={{ gridRow: "33/34", gridColumn: "39/45"}}>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-261"
              style={{ gridRow: "33/34", gridColumn: "36/39"}}>
              <label
                id="CardCreateInvoiceGroupUX-label-262"
                style={{ marginLeft:"10px",display: "flex",height:"40px", fontSize:"16px",alignItems:"center",fontWeight:"bold"}}>
                {props.languageUX === "en" ? "Total patient payments" : "ยอดผู้ป่วยจ่าย"}
              </label>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-263"
              style={{ gridRow: "33/34", gridColumn: "42/45"}}>
              <label
                id="CardCreateInvoiceGroupUX-label-264"
                style={{ marginLeft:"10px",display: "flex",height:"40px", fontSize:"16px",alignItems:"center",fontWeight:"bold"}}>
                {props.languageUX === "en" ? "Co-payment amount" : "ยอดร่วมจ่าย"}
              </label>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-265"
              style={{ gridRow: "33/34", gridColumn: "45/49"}}>
              <Input
                id="CardCreateInvoiceGroupUX-Input-266"
                readonly="true">
              </Input>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-267"
              style={{ gridRow: "36/37", gridColumn: "42/50"}}>
              <Button
                id="CardCreateInvoiceGroupUX-Button-268"
                style={{backgroundColor:"#FC9434",padding:"15px 30px", color:"#FFFFFF",fontSize:"18px",width:"100%"}}>
                {props.languageUX === "en" ? "Export Data ส่ง Payer" : "ส่งออกข้อมูล ส่งผู้ชำระเงิน"}
              </Button>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-269"
              style={{ gridRow: "36/37", gridColumn: "38/41"}}>
              <Button
                id="CardCreateInvoiceGroupUX-Button-270"
                style={{backgroundColor:"#0E98B7",padding:"15px 30px", color:"#FFFFFF",fontSize:"18px",width:"100%"}}>
                {props.languageUX === "en" ? "Print documents" : "พิมพ์เอกสาร"}
              </Button>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-271"
              style={{ gridRow: "36/37", gridColumn: "30/37"}}>
              <Button
                id="CardCreateInvoiceGroupUX-Button-272"
                style={{backgroundColor:"#27AE60",padding:"15px 30px", color:"#FFFFFF",fontSize:"18px",width:"100%"}}>
                {props.languageUX === "en" ? "Create invoice number" : "สร้างเลขที่ใบแจ้งหนี้"}
              </Button>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-273"
              style={{ gridRow: "36/37", gridColumn: "23/29"}}>
              <Button
                id="CardCreateInvoiceGroupUX-Button-274"
                size="small"
                style={{backgroundColor:"#2185D0",padding:"15px 30px", color:"#FFFFFF",fontSize:"18px",width:"100%", }}>
                {props.languageUX === "en" ? "Create reimbursement data" : "สร้างข้อมูลส่งเบิก"}
              </Button>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-275"
              style={{ gridRow: "5/6", gridColumn: "2/5"}}>
              <div
                id="CardCreateInvoiceGroupUX-div-276"
                style={{ display: "flex",  alignItems:"center",height:"100%",width:"100%"}}>
                
                <label
                  id="CardCreateInvoiceGroupUX-label-277"
                  style={{display: "flex",height:"100%", fontSize:"16px",alignItems:"center",fontWeight:"bold",marginLeft:"10px"}}>
                  {props.languageUX === "en" ? "Select rights" : "เลือกสิทธิ"}
                </label>
                <label
                  id="CardCreateInvoiceGroupUX-label-278"
                  style={{display: "flex",height:"100%", fontSize:"16px",alignItems:"center",fontWeight:"bold",marginLeft:"10px",color:"red"}}>
                  *
                </label>
              </div>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-279"
              style={{ gridRow: "5/6", gridColumn: "5/11"}}>
              <Dropdown
                id="CardCreateInvoiceGroupUX-Dropdown-280"
                selection={true}
                style={{height:"100%",width:"100%"}}>
              </Dropdown>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-281"
              style={{ gridRow: "5/6", gridColumn: "12/30"}}>
              <div
                id="CardCreateInvoiceGroupUX-div-282"
                style={{ display: "flex",  alignItems:"center",height:"100%",width:"100%"}}>
                
                <Checkbox
                  id="CardCreateInvoiceGroupUX-Checkbox-283">
                </Checkbox>
                <label
                  id="CardCreateInvoiceGroupUX-label-284"
                  style={{ marginLeft:"20px",marginRight:"20px",display: "flex",height:"40px", fontSize:"16px",alignItems:"center",fontWeight:"bold"} }>
                  {props.languageUX === "en" ? "Start date" : "ระบุวันที่ เริ่มต้น "}
                </label>
                <DateTextBox
                  id="CardCreateInvoiceGroupUX-DateTextBox-285"
                  style={{marginRight:"20px",height:"100%",width:"100%"}}>
                </DateTextBox>
                <label
                  id="CardCreateInvoiceGroupUX-label-286"
                  style={{ marginLeft:"20px",marginRight:"5px",display: "flex",height:"40px", fontSize:"16px",alignItems:"center",fontWeight:"bold"}}>
                  {props.languageUX === "en" ? "to" : "ถึง"}
                </label>
                <DateTextBox
                  id="CardCreateInvoiceGroupUX-DateTextBox-287"
                  style={{marginLeft:"20px",height:"100%",width:"100%"}}>
                </DateTextBox>
              </div>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-288"
              style={{ gridRow: "5/6", gridColumn: "30/35"}}>
              <label
                id="CardCreateInvoiceGroupUX-label-289"
                style={{display: "flex",height:"100%", fontSize:"16px",alignItems:"center",fontWeight:"bold",marginLeft:"10px"}}>
                {props.languageUX === "en" ? "The parent agency that collects the fee" : "หน่วยงานต้นสังกัดที่เรียกเก็บ"}
              </label>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-290"
              style={{ gridRow: "5/6", gridColumn: "36/42"}}>
              <Dropdown
                id="CardCreateInvoiceGroupUX-Dropdown-291"
                selection={true}
                style={{height:"100%",width:"100%"}}>
              </Dropdown>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-292"
              style={{ gridRow: "6/7", gridColumn: "2/11",paddingTop:"10px"}}>
              <div
                id="CardCreateInvoiceGroupUX-div-293"
                style={{ display: "flex",  alignItems:"center",height:"100%",width:"100%"}}>
                
                <Radio
                  id="CardCreateInvoiceGroupUX-Radio-294">
                </Radio>
                <label
                  id="CardCreateInvoiceGroupUX-label-295"
                  style={{ marginLeft:"10px",marginRight:"5px",display: "flex",height:"40px", fontSize:"16px",alignItems:"center",fontWeight:"bold"} }>
                  {props.languageUX === "en" ? "Only items yet to be invoiced" : "เฉพาะรายการที่ยังถูกสร้างใบแจ้งหนี้"}
                </label>
              </div>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-296"
              style={{ gridRow: "6/7", gridColumn: "12/25",paddingTop:"10px"}}>
              <div
                id="CardCreateInvoiceGroupUX-div-297"
                style={{ display: "flex",  alignItems:"center",height:"100%",width:"100%"}}>
                
                <Radio
                  id="CardCreateInvoiceGroupUX-Radio-298">
                </Radio>
                <label
                  id="CardCreateInvoiceGroupUX-label-299"
                  style={{ marginLeft:"10px",marginRight:"5px",display: "flex",height:"40px", fontSize:"16px",alignItems:"center",fontWeight:"bold"} }>
                  {props.languageUX === "en" ? "Invoice number from the parent company" : "เลขที่ใบแจ้งหนี้เรียกเก็บเงินจากต้นสังกัด"}
                </label>
                <Input
                  icon="search"
                  id="CardCreateInvoiceGroupUX-Input-300"
                  readonly="true"
                  style={{marginLeft:"10px",width:"300px",height:"100%"}}>
                </Input>
              </div>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-301"
              style={{ gridRow: "6/7", gridColumn: "35/40",padding:"10px"}}>
              <div
                id="CardCreateInvoiceGroupUX-div-302"
                style={{ display: "flex",  alignItems:"center",height:"100%",width:"100%"}}>
                
                <Button
                  id="CardCreateInvoiceGroupUX-Button-303"
                  style={{backgroundColor:"#3674D0",padding:"10px 15px", color:"#FFFFFF",fontSize:"18px",width:"100%"}}>
                  {props.languageUX === "en" ? "Search" : "ค้นหา"}
                </Button>
              </div>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-304"
              style={{ gridRow: "33/34", gridColumn: "23/27" }}>
              <Input
                id="CardCreateInvoiceGroupUX-Input-305"
                readonly="true">
              </Input>
            </div>
            <div
              id="CardCreateInvoiceGroupUX-div-306"
              style={{ gridRow: "33/34", gridColumn: "18/23"}}>
              <label
                id="CardCreateInvoiceGroupUX-label-307"
                style={{display: "flex",height:"100%", fontSize:"16px",alignItems:"center",fontWeight:"bold",marginLeft:"10px"}}>
                {props.languageUX === "en" ? "Amount of data that can be submitted for reimbursement" : "จำนวนข้อมูลที่ส่งเบิกได้"}
              </label>
            </div>
          </div>
        </div>
      </div>
    )
}

CardCreateInvoiceGroupUX.displayName = "CardCreateInvoiceGroupUX";
export default React.memo(CardCreateInvoiceGroupUX)

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"#FFFFF\",width: \"calc(-150px + 100vw)\",height: \"calc(100vh - 30px)\" ,padding:\"10px\",borderRadius: 3,border : \"solid 0.5px \",borderColor:\"transparent\", overflow: \"auto\", }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 158,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form small"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-158"
        },
        "style": {
          "type": "code",
          "value": "{display:props.activeTab===\"IssueInv\"?\"\":\"none\"}"
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormGroup",
      "parent": 158,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormGroup-159"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "FormField",
      "parent": 159,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-160"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 161,
      "name": "FormField",
      "parent": 159,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-161"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 162,
      "name": "FormField",
      "parent": 159,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-162"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 163,
      "name": "FormField",
      "parent": 159,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-163"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "FormField",
      "parent": 159,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-164"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "FormField",
      "parent": 159,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-165"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "FormField",
      "parent": 159,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-166"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "FormField",
      "parent": 159,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-167"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 169,
      "name": "FormField",
      "parent": 159,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-169"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 378,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 162,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-171"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-172"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 164,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานต้นสังกัดที่เรียกเก็บ",
          "valueEN": "The parent company that collects the fee"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-173"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\", width: \"100%\"}"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "Checkbox",
      "parent": 161,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterIssueInv?.isDate"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Checkbox-175"
        },
        "label": {
          "type": "value",
          "value": "วันที่ออกใบเสร็จ",
          "valueEN": "Receipt date"
        },
        "name": {
          "type": "value",
          "value": "filterIssueInv.isDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "onClick": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 178,
      "name": "DateTextBox",
      "parent": 171,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.filterIssueInv?.isDate"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-DateTextBox-178"
        },
        "onChange": {
          "type": "code",
          "value": "(value: string)=>props.onChangeFilter?.(null,{name:\"filterIssueInv.startDate\", value})"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterIssueInv?.startDate || \"\""
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 179,
      "name": "DateTextBox",
      "parent": 172,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.filterIssueInv?.isDate"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-DateTextBox-179"
        },
        "onChange": {
          "type": "code",
          "value": "(value: string)=>props.onChangeFilter?.(null,{name:\"filterIssueInv.endDate\", value})"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "tabIndex": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.filterIssueInv?.endDate || \"\""
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "div",
      "parent": 167,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-181"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\", width: \"100%\"}"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "div",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-182"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "div",
      "parent": 182,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-183"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",height:\"100%\", fontSize:\"1.15rem\",fontWeight:\"bold\",alignItems:\"center\", padding: \"2.5px 0px\"}"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 184,
      "name": "label",
      "parent": 183,
      "props": {
        "children": {
          "type": "code",
          "value": "props.table?.title || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-184"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 234,
      "name": "FormGroup",
      "parent": 158,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormGroup-234"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": null,
      "id": 245,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-245"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 433,
      "void": false
    },
    {
      "from": null,
      "id": 246,
      "name": "div",
      "parent": 245,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-246"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(40, 1fr)\",\"gridTemplateColumns\":\"repeat(50, 1fr)\"}"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": null,
      "id": 247,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-247"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/4\", gridColumn: \"2/50\"}"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": null,
      "id": 248,
      "name": "div",
      "parent": 247,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-248"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",height:\"100%\", fontSize:\"18px\",fontWeight:\"bold\",alignItems:\"center\"}"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": null,
      "id": 249,
      "name": "label",
      "parent": 248,
      "props": {
        "children": {
          "type": "value",
          "value": "ออกใบแจ้งหนี้เรียกเก็บเงินต้นสังกัด",
          "valueEN": "Issue invoices to the parent company"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-249"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": null,
      "id": 250,
      "name": "hr",
      "parent": 247,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-hr-250"
        }
      },
      "seq": 250,
      "void": true
    },
    {
      "from": null,
      "id": 251,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-251"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"8/32\", gridColumn: \"2/50\"}"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 252,
      "name": "Table",
      "parent": 251,
      "props": {
        "columns": {
          "type": "value",
          "value": ""
        },
        "defaultPageSize": {
          "type": "value",
          "value": "10"
        },
        "headers": {
          "type": "value",
          "value": " ,Date Transaction,เลขที่ใบแจ้งหนี้,HN, Encounter, ID Card No.,Bill No., Amount, Claim Amount, Paid, สิทธิ,ต้นสังกัด, "
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Table-252"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-253"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"33/34\", gridColumn: \"28/30\"}"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": null,
      "id": 254,
      "name": "label",
      "parent": 253,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดเบิก",
          "valueEN": "Total withdrawal"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-254"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft:\"10px\",display: \"flex\",height:\"40px\", fontSize:\"16px\",alignItems:\"center\",fontWeight:\"bold\"}"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": null,
      "id": 255,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-255"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"33/34\", gridColumn: \"30/35\"}"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 256,
      "name": "Input",
      "parent": 255,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Input-256"
        },
        "readonly": {
          "type": "value",
          "value": "true"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": null,
      "id": 257,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-257"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"33/34\", gridColumn: \"40/40\"}"
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 258,
      "name": "Input",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Input-258"
        },
        "readonly": {
          "type": "value",
          "value": "true"
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": null,
      "id": 259,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-259"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"33/34\", gridColumn: \"39/40\"}"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": null,
      "id": 260,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-260"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"33/34\", gridColumn: \"39/45\"}"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": null,
      "id": 261,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-261"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"33/34\", gridColumn: \"36/39\"}"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": null,
      "id": 262,
      "name": "label",
      "parent": 261,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดผู้ป่วยจ่าย",
          "valueEN": "Total patient payments"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-262"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft:\"10px\",display: \"flex\",height:\"40px\", fontSize:\"16px\",alignItems:\"center\",fontWeight:\"bold\"}"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": null,
      "id": 263,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-263"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"33/34\", gridColumn: \"42/45\"}"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": null,
      "id": 264,
      "name": "label",
      "parent": 263,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดร่วมจ่าย",
          "valueEN": "Co-payment amount"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-264"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft:\"10px\",display: \"flex\",height:\"40px\", fontSize:\"16px\",alignItems:\"center\",fontWeight:\"bold\"}"
        }
      },
      "seq": 264,
      "void": false
    },
    {
      "from": null,
      "id": 265,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-265"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"33/34\", gridColumn: \"45/49\"}"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 266,
      "name": "Input",
      "parent": 265,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Input-266"
        },
        "readonly": {
          "type": "value",
          "value": "true"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": null,
      "id": 267,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-267"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"36/37\", gridColumn: \"42/50\"}"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 268,
      "name": "Button",
      "parent": 267,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งออกข้อมูล ส่งผู้ชำระเงิน",
          "valueEN": "Export Data ส่ง Payer"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Button-268"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor:\"#FC9434\",padding:\"15px 30px\", color:\"#FFFFFF\",fontSize:\"18px\",width:\"100%\"}"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": null,
      "id": 269,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-269"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"36/37\", gridColumn: \"38/41\"}"
        }
      },
      "seq": 269,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 270,
      "name": "Button",
      "parent": 269,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์เอกสาร",
          "valueEN": "Print documents"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Button-270"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor:\"#0E98B7\",padding:\"15px 30px\", color:\"#FFFFFF\",fontSize:\"18px\",width:\"100%\"}"
        }
      },
      "seq": 270,
      "void": false
    },
    {
      "from": null,
      "id": 271,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-271"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"36/37\", gridColumn: \"30/37\"}"
        }
      },
      "seq": 271,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 272,
      "name": "Button",
      "parent": 271,
      "props": {
        "children": {
          "type": "value",
          "value": "สร้างเลขที่ใบแจ้งหนี้",
          "valueEN": "Create invoice number"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Button-272"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor:\"#27AE60\",padding:\"15px 30px\", color:\"#FFFFFF\",fontSize:\"18px\",width:\"100%\"}"
        }
      },
      "seq": 272,
      "void": false
    },
    {
      "from": null,
      "id": 273,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-273"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"36/37\", gridColumn: \"23/29\"}"
        }
      },
      "seq": 273,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 274,
      "name": "Button",
      "parent": 273,
      "props": {
        "children": {
          "type": "value",
          "value": "สร้างข้อมูลส่งเบิก",
          "valueEN": "Create reimbursement data"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Button-274"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor:\"#2185D0\",padding:\"15px 30px\", color:\"#FFFFFF\",fontSize:\"18px\",width:\"100%\", }"
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": null,
      "id": 275,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-275"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"5/6\", gridColumn: \"2/5\"}"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": null,
      "id": 276,
      "name": "div",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-276"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  alignItems:\"center\",height:\"100%\",width:\"100%\"}"
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": null,
      "id": 277,
      "name": "label",
      "parent": 276,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกสิทธิ",
          "valueEN": "Select rights"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-277"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",height:\"100%\", fontSize:\"16px\",alignItems:\"center\",fontWeight:\"bold\",marginLeft:\"10px\"}"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": null,
      "id": 278,
      "name": "label",
      "parent": 276,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-278"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",height:\"100%\", fontSize:\"16px\",alignItems:\"center\",fontWeight:\"bold\",marginLeft:\"10px\",color:\"red\"}"
        }
      },
      "seq": 278,
      "void": false
    },
    {
      "from": null,
      "id": 279,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-279"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"5/6\", gridColumn: \"5/11\"}"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 280,
      "name": "Dropdown",
      "parent": 279,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Dropdown-280"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height:\"100%\",width:\"100%\"}"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": null,
      "id": 281,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-281"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"5/6\", gridColumn: \"12/30\"}"
        }
      },
      "seq": 281,
      "void": false
    },
    {
      "from": null,
      "id": 282,
      "name": "div",
      "parent": 281,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-282"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  alignItems:\"center\",height:\"100%\",width:\"100%\"}"
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 283,
      "name": "Checkbox",
      "parent": 282,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Checkbox-283"
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": null,
      "id": 284,
      "name": "label",
      "parent": 282,
      "props": {
        "children": {
          "type": "value",
          "value": "ระบุวันที่ เริ่มต้น ",
          "valueEN": "Start date"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-284"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft:\"20px\",marginRight:\"20px\",display: \"flex\",height:\"40px\", fontSize:\"16px\",alignItems:\"center\",fontWeight:\"bold\"} "
        }
      },
      "seq": 284,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 285,
      "name": "DateTextBox",
      "parent": 282,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-DateTextBox-285"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"20px\",height:\"100%\",width:\"100%\"}"
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": null,
      "id": 286,
      "name": "label",
      "parent": 282,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-286"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft:\"20px\",marginRight:\"5px\",display: \"flex\",height:\"40px\", fontSize:\"16px\",alignItems:\"center\",fontWeight:\"bold\"}"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 287,
      "name": "DateTextBox",
      "parent": 282,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-DateTextBox-287"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"20px\",height:\"100%\",width:\"100%\"}"
        }
      },
      "seq": 287,
      "void": false
    },
    {
      "from": null,
      "id": 288,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-288"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"5/6\", gridColumn: \"30/35\"}"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": null,
      "id": 289,
      "name": "label",
      "parent": 288,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานต้นสังกัดที่เรียกเก็บ",
          "valueEN": "The parent agency that collects the fee"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-289"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",height:\"100%\", fontSize:\"16px\",alignItems:\"center\",fontWeight:\"bold\",marginLeft:\"10px\"}"
        }
      },
      "seq": 289,
      "void": false
    },
    {
      "from": null,
      "id": 290,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-290"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"5/6\", gridColumn: \"36/42\"}"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 291,
      "name": "Dropdown",
      "parent": 290,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Dropdown-291"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height:\"100%\",width:\"100%\"}"
        }
      },
      "seq": 291,
      "void": false
    },
    {
      "from": null,
      "id": 292,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-292"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"2/11\",paddingTop:\"10px\"}"
        }
      },
      "seq": 292,
      "void": false
    },
    {
      "from": null,
      "id": 293,
      "name": "div",
      "parent": 292,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-293"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  alignItems:\"center\",height:\"100%\",width:\"100%\"}"
        }
      },
      "seq": 293,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 294,
      "name": "Radio",
      "parent": 293,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Radio-294"
        }
      },
      "seq": 294,
      "void": false
    },
    {
      "from": null,
      "id": 295,
      "name": "label",
      "parent": 293,
      "props": {
        "children": {
          "type": "value",
          "value": "เฉพาะรายการที่ยังถูกสร้างใบแจ้งหนี้",
          "valueEN": "Only items yet to be invoiced"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-295"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft:\"10px\",marginRight:\"5px\",display: \"flex\",height:\"40px\", fontSize:\"16px\",alignItems:\"center\",fontWeight:\"bold\"} "
        }
      },
      "seq": 295,
      "void": false
    },
    {
      "from": null,
      "id": 296,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-296"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"12/25\",paddingTop:\"10px\"}"
        }
      },
      "seq": 296,
      "void": false
    },
    {
      "from": null,
      "id": 297,
      "name": "div",
      "parent": 296,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-297"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  alignItems:\"center\",height:\"100%\",width:\"100%\"}"
        }
      },
      "seq": 297,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 298,
      "name": "Radio",
      "parent": 297,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Radio-298"
        }
      },
      "seq": 298,
      "void": false
    },
    {
      "from": null,
      "id": 299,
      "name": "label",
      "parent": 297,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบแจ้งหนี้เรียกเก็บเงินจากต้นสังกัด",
          "valueEN": "Invoice number from the parent company"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-299"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft:\"10px\",marginRight:\"5px\",display: \"flex\",height:\"40px\", fontSize:\"16px\",alignItems:\"center\",fontWeight:\"bold\"} "
        }
      },
      "seq": 299,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 300,
      "name": "Input",
      "parent": 297,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Input-300"
        },
        "readonly": {
          "type": "value",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"10px\",width:\"300px\",height:\"100%\"}"
        }
      },
      "seq": 300,
      "void": false
    },
    {
      "from": null,
      "id": 301,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-301"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"6/7\", gridColumn: \"35/40\",padding:\"10px\"}"
        }
      },
      "seq": 301,
      "void": false
    },
    {
      "from": null,
      "id": 302,
      "name": "div",
      "parent": 301,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-302"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  alignItems:\"center\",height:\"100%\",width:\"100%\"}"
        }
      },
      "seq": 302,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 303,
      "name": "Button",
      "parent": 302,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Button-303"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor:\"#3674D0\",padding:\"10px 15px\", color:\"#FFFFFF\",fontSize:\"18px\",width:\"100%\"}"
        }
      },
      "seq": 303,
      "void": false
    },
    {
      "from": null,
      "id": 304,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-304"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"33/34\", gridColumn: \"23/27\" }"
        }
      },
      "seq": 304,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 305,
      "name": "Input",
      "parent": 304,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Input-305"
        },
        "readonly": {
          "type": "value",
          "value": "true"
        }
      },
      "seq": 305,
      "void": false
    },
    {
      "from": null,
      "id": 306,
      "name": "div",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-306"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"33/34\", gridColumn: \"18/23\"}"
        }
      },
      "seq": 306,
      "void": false
    },
    {
      "from": null,
      "id": 307,
      "name": "label",
      "parent": 306,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนข้อมูลที่ส่งเบิกได้",
          "valueEN": "Amount of data that can be submitted for reimbursement"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-307"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",height:\"100%\", fontSize:\"16px\",alignItems:\"center\",fontWeight:\"bold\",marginLeft:\"10px\"}"
        }
      },
      "seq": 307,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 308,
      "name": "Table",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "value",
          "value": ""
        },
        "data": {
          "type": "code",
          "value": "props.billingTransactionItems"
        },
        "defaultPageSize": {
          "type": "value",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": " Date Transaction,เลขที่ใบแจ้งหนี้,HN, Encounter, ID Card No.,Invoice No.,Bill No.,จุดรับชำระเงิน,Amount, Claim Amount, Paid, สิทธิ,ต้นสังกัด, "
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Table-308"
        },
        "keys": {
          "type": "value",
          "value": "dt_tran,lot_no,hn,encounter_id,pid,invoice_no,bill_no,station_detail,amount,claim_amount,paid,coverage_payer,payer,detail"
        },
        "minRows": {
          "type": "value",
          "value": "8"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100dvh - 27.5rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "125,^110,^85,^85,^120,^140,^75,^150,^100,^100,^100,^105,^135,100"
        }
      },
      "seq": 309,
      "void": false
    },
    {
      "from": null,
      "id": 309,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form small"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-309"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 381,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 310,
      "name": "FormGroup",
      "parent": 309,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormGroup-310"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 310,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 311,
      "name": "FormGroup",
      "parent": 309,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormGroup-311"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 311,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 312,
      "name": "FormField",
      "parent": 310,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-312"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 313,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 313,
      "name": "FormField",
      "parent": 310,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-313"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 314,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 314,
      "name": "FormField",
      "parent": 310,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-314"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 315,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 315,
      "name": "FormField",
      "parent": 310,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-315"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 316,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 316,
      "name": "FormField",
      "parent": 310,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-316"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 317,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 317,
      "name": "FormField",
      "parent": 310,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-317"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 318,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 318,
      "name": "FormField",
      "parent": 310,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-318"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 319,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 319,
      "name": "FormField",
      "parent": 310,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-319"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 328,
      "void": false
    },
    {
      "from": null,
      "id": 320,
      "name": "div",
      "parent": 312,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนข้อมูลที่เบิกได้",
          "valueEN": "Amount of data available for withdrawal"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-320"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\", width: \"100%\"}"
        }
      },
      "seq": 320,
      "void": false
    },
    {
      "from": null,
      "id": 321,
      "name": "div",
      "parent": 314,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดเบิก",
          "valueEN": "Total withdrawal"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-321"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\", width: \"100%\"}"
        }
      },
      "seq": 321,
      "void": false
    },
    {
      "from": null,
      "id": 322,
      "name": "div",
      "parent": 316,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดผู้ป่วยจ่าย",
          "valueEN": "Total patient payments"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-322"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\", width: \"100%\"}"
        }
      },
      "seq": 322,
      "void": false
    },
    {
      "from": null,
      "id": 323,
      "name": "div",
      "parent": 318,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดร่วมจ่าย",
          "valueEN": "Co-payment amount"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-323"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\", width: \"100%\"}"
        }
      },
      "seq": 323,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 324,
      "name": "Input",
      "parent": 313,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Input-324"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        },
        "value": {
          "type": "code",
          "value": "props.summary?.total_rows ?? \"\""
        }
      },
      "seq": 324,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 325,
      "name": "Input",
      "parent": 315,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Input-325"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        },
        "value": {
          "type": "code",
          "value": "props.summary?.total_sent_claim_price|| \"\""
        }
      },
      "seq": 325,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 326,
      "name": "Input",
      "parent": 317,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Input-326"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        },
        "value": {
          "type": "code",
          "value": "props.summary?.total_paid|| props.summary?.total_paid_price|| \"\""
        }
      },
      "seq": 326,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 327,
      "name": "Input",
      "parent": 319,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Input-327"
        },
        "readOnly": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        },
        "value": {
          "type": "code",
          "value": "props.summary?.total_other_pay|| props.summary?.total_other_pay_price|| \"\""
        }
      },
      "seq": 327,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 328,
      "name": "FormField",
      "parent": 310,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-328"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 312,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 338,
      "name": "FormField",
      "parent": 311,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-338"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 369,
      "void": false
    },
    {
      "from": null,
      "id": 343,
      "name": "div",
      "parent": 338,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-343"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", flex: \"1\", paddingTop: \"15px\"}"
        }
      },
      "seq": 343,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 344,
      "name": "Button",
      "parent": 343,
      "props": {
        "children": {
          "type": "value",
          "value": "สร้างข้อมูลส่งเบิก",
          "valueEN": "Create reimbursement data"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Button-344"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCreateAR"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.table?.buttons?.includes(\"create_ar\")? \"\":\"none\",}"
        }
      },
      "seq": 344,
      "void": false
    },
    {
      "from": null,
      "id": 352,
      "name": "div",
      "parent": 169,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-352"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 352,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 354,
      "name": "FormField",
      "parent": 234,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-354"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", display: \"none\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 355,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 355,
      "name": "FormField",
      "parent": 234,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-355"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 358,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 358,
      "name": "FormField",
      "parent": 234,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-358"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 360,
      "void": false
    },
    {
      "from": null,
      "id": 359,
      "name": "div",
      "parent": 358,
      "props": {
        "children": {
          "type": "code",
          "value": "props.arInvoiceSearch"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-359"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 359,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 364,
      "name": "Checkbox",
      "parent": 354,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterIssueInv?.isNoInvoice"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Checkbox-364"
        },
        "label": {
          "type": "value",
          "value": "เฉพาะรายการที่ยังไม่ถูกสร้างใบแจ้งหนี้",
          "valueEN": "Only items that have not yet been invoiced"
        },
        "name": {
          "type": "value",
          "value": "filterIssueInv.isNoInvoice"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "onClick": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 364,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 365,
      "name": "Checkbox",
      "parent": 355,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedInvoiceType === \"fromPayer\""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Checkbox-365"
        },
        "label": {
          "type": "value",
          "value": "เลขที่ใบแจ้งหนี้เรียกเก็บจากต้นสังกัด",
          "valueEN": "Invoice number from the parent company"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCheckRadio?.(\"fromPayer\")"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 365,
      "void": false
    },
    {
      "from": null,
      "id": 369,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "field"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-369"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 330,
      "void": false
    },
    {
      "from": null,
      "id": 370,
      "name": "div",
      "parent": 343,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonCreate"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-370"
        },
        "style": {
          "type": "code",
          "value": "{display: props.table?.buttons?.includes(\"create_ar_transaction\")?\"\":\"none\", marginLeft: \"0.75rem\"}"
        }
      },
      "seq": 346,
      "void": false
    },
    {
      "from": null,
      "id": 371,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-371"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", marginBottom: \"0.75rem\"}"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 372,
      "name": "Button",
      "parent": 371,
      "props": {
        "children": {
          "type": "value",
          "value": "ออกใบแจ้งหนี้เรียกเก็บเงินต้นสังกัด",
          "valueEN": "Issue Invoice to the parent company"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"IssueInv\"? \"blue\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Button-372"
        },
        "name": {
          "type": "value",
          "value": "IssueInv"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.75rem\"}"
        }
      },
      "seq": 372,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 373,
      "name": "Button",
      "parent": 371,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการที่ออกใบแจ้งหนี้แล้ว",
          "valueEN": "Invoiced Items"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"InvIssued\"? \"blue\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Button-373"
        },
        "name": {
          "type": "value",
          "value": "InvIssued"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.75rem\"}"
        }
      },
      "seq": 373,
      "void": false
    },
    {
      "from": null,
      "id": 374,
      "name": "div",
      "parent": 182,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-374"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"0.5rem\"}"
        }
      },
      "seq": 374,
      "void": false
    },
    {
      "from": null,
      "id": 375,
      "name": "label",
      "parent": 160,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกสิทธิ",
          "valueEN": "Select rights"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-375"
        }
      },
      "seq": 375,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 376,
      "name": "Dropdown",
      "parent": 166,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Dropdown-376"
        },
        "name": {
          "type": "value",
          "value": "filterIssueInv.coveragePayer"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.coveragePayerOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", fontSize: \"1em\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterIssueInv?.coveragePayer|| \"\""
        }
      },
      "seq": 376,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 377,
      "name": "Dropdown",
      "parent": 165,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Dropdown-377"
        },
        "name": {
          "type": "value",
          "value": "filterIssueInv.payer"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.payerOptions "
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", fontSize: \"1em\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterIssueInv?.payer|| \"\""
        }
      },
      "seq": 377,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 378,
      "name": "FormField",
      "parent": 234,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-378"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 378,
      "void": false
    },
    {
      "from": null,
      "id": 379,
      "name": "div",
      "parent": 378,
      "props": {
        "children": {
          "type": "code",
          "value": "props.issueInvPatientSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-379"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 380,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 380,
      "name": "Checkbox",
      "parent": 378,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterIssueInv?.isPatient"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Checkbox-380"
        },
        "label": {
          "type": "value",
          "value": "HN",
          "valueEN": "HN"
        },
        "name": {
          "type": "value",
          "value": "filterIssueInv.isPatient"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 379,
      "void": false
    },
    {
      "from": null,
      "id": 381,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form small"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-381"
        },
        "style": {
          "type": "code",
          "value": "{display:props.activeTab===\"InvIssued\"?\"\":\"none\"}"
        }
      },
      "seq": 308,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 382,
      "name": "FormGroup",
      "parent": 381,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormGroup-382"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 382,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 383,
      "name": "FormGroup",
      "parent": 381,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormGroup-383"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 383,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 384,
      "name": "FormField",
      "parent": 382,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-384"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 384,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 385,
      "name": "FormField",
      "parent": 382,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-385"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 385,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 386,
      "name": "FormField",
      "parent": 382,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-386"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 386,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 387,
      "name": "FormField",
      "parent": 382,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-387"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 387,
      "void": false
    },
    {
      "from": null,
      "id": 388,
      "name": "label",
      "parent": 384,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบแจ้งหนี้เรียกเก็บเงินจากต้นสังกัด",
          "valueEN": "Invoice number from the parent company"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-388"
        }
      },
      "seq": 388,
      "void": false
    },
    {
      "from": null,
      "id": 389,
      "name": "div",
      "parent": 385,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchInvoiceGroup"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-389"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 389,
      "void": false
    },
    {
      "from": null,
      "id": 390,
      "name": "label",
      "parent": 386,
      "props": {
        "children": {
          "type": "value",
          "value": "สิทธิ",
          "valueEN": "Rights"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-390"
        }
      },
      "seq": 390,
      "void": false
    },
    {
      "from": null,
      "id": 391,
      "name": "label",
      "parent": 387,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานต้นสังกัดที่เรียกเก็บ",
          "valueEN": "The parent company that collects the fee"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-391"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 391,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 392,
      "name": "FormField",
      "parent": 382,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-392"
        }
      },
      "seq": 392,
      "void": false
    },
    {
      "from": null,
      "id": 393,
      "name": "div",
      "parent": 392,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-393"
        }
      },
      "seq": 393,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 394,
      "name": "Input",
      "parent": 387,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Input-394"
        },
        "value": {
          "type": "code",
          "value": "props.filterInvIssued?.arTransaction?.payer_code_name||\"\""
        }
      },
      "seq": 394,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 395,
      "name": "Input",
      "parent": 386,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Input-395"
        },
        "value": {
          "type": "code",
          "value": "props.filterInvIssued?.arTransaction?.coverage_code_name||\"\""
        }
      },
      "seq": 395,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 396,
      "name": "FormField",
      "parent": 383,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-396"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 396,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 397,
      "name": "FormField",
      "parent": 383,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-397"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 397,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 398,
      "name": "FormField",
      "parent": 383,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-398"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 398,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 399,
      "name": "FormField",
      "parent": 383,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-399"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 399,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 400,
      "name": "FormField",
      "parent": 383,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-400"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 400,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 401,
      "name": "FormField",
      "parent": 383,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-401"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 401,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 402,
      "name": "FormField",
      "parent": 383,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-402"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 402,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 403,
      "name": "FormField",
      "parent": 383,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-403"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 403,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 404,
      "name": "Checkbox",
      "parent": 396,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterInvIssued?.isDate|| false"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Checkbox-404"
        },
        "label": {
          "type": "value",
          "value": "วันที่ออกใบเสร็จ",
          "valueEN": "Receipt Date"
        },
        "name": {
          "type": "value",
          "value": "filterInvIssued.isDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 404,
      "void": false
    },
    {
      "from": null,
      "id": 405,
      "name": "div",
      "parent": 397,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-405"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 405,
      "void": false
    },
    {
      "from": null,
      "id": 406,
      "name": "div",
      "parent": 399,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-406"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 406,
      "void": false
    },
    {
      "from": null,
      "id": 407,
      "name": "label",
      "parent": 398,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-label-407"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\", width: \"100%\"}"
        }
      },
      "seq": 407,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 408,
      "name": "Checkbox",
      "parent": 400,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterInvIssued?.isPatient|| false"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Checkbox-408"
        },
        "label": {
          "type": "value",
          "value": "HN",
          "valueEN": "HN"
        },
        "name": {
          "type": "value",
          "value": "filterInvIssued.isPatient"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 408,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 409,
      "name": "Checkbox",
      "parent": 402,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterInvIssued?.isEncounter|| false"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Checkbox-409"
        },
        "label": {
          "type": "value",
          "value": "AN",
          "valueEN": "AN"
        },
        "name": {
          "type": "value",
          "value": "filterInvIssued.isEncounter"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 409,
      "void": false
    },
    {
      "from": null,
      "id": 410,
      "name": "div",
      "parent": 403,
      "props": {
        "children": {
          "type": "code",
          "value": "props.invIssuedSearchEncounter"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-410"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 410,
      "void": false
    },
    {
      "from": null,
      "id": 411,
      "name": "div",
      "parent": 401,
      "props": {
        "children": {
          "type": "code",
          "value": "props.invIssuedPatientSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-411"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 411,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 412,
      "name": "DateTextBox",
      "parent": 405,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.filterInvIssued?.isDate"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-DateTextBox-412"
        },
        "onChange": {
          "type": "code",
          "value": "(value: string)=>props.onChangeFilter?.(null,{name:\"filterInvIssued.startDate\", value})"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterInvIssued?.startDate || \"\""
        }
      },
      "seq": 412,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 413,
      "name": "DateTextBox",
      "parent": 406,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.filterInvIssued?.isDate"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-DateTextBox-413"
        },
        "onChange": {
          "type": "code",
          "value": "(value: string)=>props.onChangeFilter?.(null,{name:\"filterInvIssued.endDate\", value})"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterInvIssued?.endDate || \"\""
        }
      },
      "seq": 413,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 414,
      "name": "FormField",
      "parent": 234,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-414"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 414,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 415,
      "name": "Checkbox",
      "parent": 414,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterIssueInv?.isEncounter"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Checkbox-415"
        },
        "label": {
          "type": "value",
          "value": "AN",
          "valueEN": "AN"
        },
        "name": {
          "type": "value",
          "value": "filterIssueInv.isEncounter"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 415,
      "void": false
    },
    {
      "from": null,
      "id": 416,
      "name": "div",
      "parent": 414,
      "props": {
        "children": {
          "type": "code",
          "value": "props.issueInvSearchEncounter"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-416"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 416,
      "void": false
    },
    {
      "from": null,
      "id": 417,
      "name": "div",
      "parent": 343,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonDownloadExcel"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-417"
        },
        "style": {
          "type": "code",
          "value": "{display: props.table?.buttons?.includes(\"download_excel\")? \"\":\"none\", marginLeft: \"0.75rem\"}"
        }
      },
      "seq": 432,
      "void": false
    },
    {
      "from": null,
      "id": 418,
      "name": "div",
      "parent": 343,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-418"
        },
        "style": {
          "type": "code",
          "value": "{display: props.table?.buttons?.includes(\"print_report\")? \"\":\"none\", marginLeft: \"0.75rem\"}"
        }
      },
      "seq": 418,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 419,
      "name": "FormGroup",
      "parent": 381,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormGroup-419"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 419,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 421,
      "name": "FormField",
      "parent": 419,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-421"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 421,
      "void": false
    },
    {
      "from": null,
      "id": 423,
      "name": "div",
      "parent": 421,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-423"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 425,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 424,
      "name": "Dropdown",
      "parent": 423,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Dropdown-424"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "filterInvIssued.station"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.bilStationOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filterInvIssued?.station"
        }
      },
      "seq": 424,
      "void": false
    },
    {
      "from": null,
      "id": 425,
      "name": "div",
      "parent": 421,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-425"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 423,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 426,
      "name": "Checkbox",
      "parent": 425,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterInvIssued?.isStation || false"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Checkbox-426"
        },
        "label": {
          "type": "value",
          "value": "จุดรับชำระเงิน",
          "valueEN": "Payment Point"
        },
        "name": {
          "type": "value",
          "value": "filterInvIssued.isStation"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 426,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 427,
      "name": "FormField",
      "parent": 234,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-FormField-427"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 427,
      "void": false
    },
    {
      "from": null,
      "id": 428,
      "name": "div",
      "parent": 427,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-428"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 428,
      "void": false
    },
    {
      "from": null,
      "id": 429,
      "name": "div",
      "parent": 427,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-429"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 429,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 430,
      "name": "Checkbox",
      "parent": 428,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterIssueInv?.isStation || false"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Checkbox-430"
        },
        "label": {
          "type": "value",
          "value": "จุดรับชำระเงิน",
          "valueEN": "Payment Point"
        },
        "name": {
          "type": "value",
          "value": "filterIssueInv.isStation"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 430,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 431,
      "name": "Dropdown",
      "parent": 429,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-Dropdown-431"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "filterIssueInv.station"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.bilStationOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filterIssueInv?.station"
        }
      },
      "seq": 431,
      "void": false
    },
    {
      "from": null,
      "id": 432,
      "name": "div",
      "parent": 343,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonCancel"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-432"
        },
        "style": {
          "type": "code",
          "value": "{display: props.table?.buttons?.includes(\"cancel_ar\")? \"\":\"none\", marginLeft: \"0.75rem\"}"
        }
      },
      "seq": 417,
      "void": false
    },
    {
      "from": null,
      "id": 433,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.paginationComponent"
        },
        "id": {
          "type": "value",
          "value": "CardCreateInvoiceGroupUX-div-433"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", flex: \"1 0 auto\" , margin: \"5px\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 371,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": true,
  "memo": true,
  "name": "CardCreateInvoiceGroupUX",
  "project": "CLM CU",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 100
}

*********************************************************************************** */
